import { render, staticRenderFns } from "./ContractCloneComparison.vue?vue&type=template&id=96d2b3fa&scoped=true&"
import script from "./ContractCloneComparison.vue?vue&type=script&lang=js&"
export * from "./ContractCloneComparison.vue?vue&type=script&lang=js&"
import style0 from "./ContractCloneComparison.vue?vue&type=style&index=0&id=96d2b3fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d2b3fa",
  null
  
)

export default component.exports